import React from 'react';
import './Evolution.scss';
import { isMobile } from 'react-device-detect';

import Carousel from '../../components/Carousel/Carousel';

import ImageDesktop from '../../assets/img/evolution/evolution-image-desktop.png';
import ImageMobile from '../../assets/img/evolution/evolution-image-mobile.png';

import evolutionPhotos from './photos.js';

const Evolution = () => {

  // render
  return (
    <section className="section-evolution">
      <div className="container">
        <div className="section-title">Evolução de obras</div>

        <div className="image">
          {isMobile ?
            <img src={ImageMobile} alt="Imagem" />
            :
            <img src={ImageDesktop} alt="Imagem" />
          }
        </div>
      </div>

      <div className="photos">
        <Carousel items={evolutionPhotos} />
      </div>
    </section>
  );
}

export default Evolution;
